var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"账单组成明细","width":"800","footer-hide":""},model:{value:(_vm.showBillDetailModal),callback:function ($$v) {_vm.showBillDetailModal=$$v},expression:"showBillDetailModal"}},[_c('div',[_c('Table',{attrs:{"stripe":"","border":"","data":_vm.list,"columns":_vm.column}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }